export function formatSupportTraffic(value:number|null){
  if(value===null||!Number.isFinite(value)||value<0)return 'טרם נמדדה';
  const units=['B','KB','MB','GB','TB','PB'];let unit=0;while(value>=1024&&unit<units.length-1){value/=1024;unit++;}
  return `${new Intl.NumberFormat('he-IL',{maximumFractionDigits:1}).format(value)} ${units[unit]}`;
}
